<template>
  <div>
    <v-data-table
      v-model="selected"
      class="run-table"
      :headers="headers"
      :items="items"
      :disable-pagination="true"
      :hide-default-footer="true"
      :loading="loading"
      item-key="name"
      dense
      @click:row="onItemClick"
    >
      <template v-slot:item.created="{ item }">
        {{ $moment(item.created).format() }}
      </template>
      <template v-slot:item.pages="{ item }">
        <span>{{ item.valid_pages || 0 }}</span>
        <span>/</span>
        <span>{{ item.total_pages || 0 }}</span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    'items': {
      type: Array,
      default: () => [],
    },
    'loading': {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selected: [],
    headers: [
      {
        text: 'Источник',
        align: 'start',
        value: 'source.name',
      },
      {
        text: 'Запуск',
        value: 'created',
      },
      {
        text: 'Страниц',
        value: 'pages',
      },
      {
        text: 'Статус',
        value: 'status_name',
      },
    ],
  }),
  methods: {
    onItemClick(value) {
      this.$emit('select', value)
    },
  },
})
</script>
<style scoped>
.run-table {
  cursor: pointer;
}
</style>
